/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

export interface DropletIconProps {
  color?: string;
  size?: IconSize | number;
}

/*
 * Defines the Design Language System (DLS) Droplet Icon component.
 */
export const DropletIcon = ({size = IconSize.large, color = dlsColor('aaBlue')}: DropletIconProps) => {
  const {iconSize} = useIconDLS({size});
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 21 28" fill="none" xmlns="http://www.w3.org/2000/svg" >
      <path d="M10.5032 26.0455C7.98392 26.0455 5.56772 25.0601 3.7857 23.3059C2.00369 21.5517 1.0017 19.1722 1 16.6906C1 11.5195 7.79168 1.00633 10.5032 1C13.5232 1 20 11.5195 20 16.6906C20 17.9191 19.7544 19.1356 19.2771 20.2705C18.7998 21.4055 18.1003 22.4368 17.2185 23.3055C16.3366 24.1742 15.2897 24.8632 14.1375 25.3334C12.9853 25.8035 11.7504 26.0455 10.5032 26.0455" stroke={color} strokeWidth="2" strokeMiterlimit="10"/>
      <path d="M13 21C13.9201 20.463 14.6771 19.7236 15.2014 18.8498C15.7257 17.976 16.0003 16.996 16 16" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
    </svg>
  );
};
